import { PropsWithChildren } from 'react'
import Styles from './ContextMenu.module.scss'

export const ItemContent = ({ children }: PropsWithChildren<{}>) => <div className={Styles.itemContent}>{children}</div>
